<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/content" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline primary--text">{{contentData.name}}</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-2" xs12>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="px-2 pb-2" xs12 md7>
          <v-text-field
            label="Content Name"
            v-model.trim="newName"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 md9>
          <v-text-field
            label="Instructions"
            v-model.trim="newContent.instructions"
            rows="3"
            hide-details
            textarea
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 md9>
          <v-card class="pa-0 elevation-0">
            <r-quill :options="options" :content="newContent.descText"></r-quill>
          </v-card>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12>
          <v-btn
            @click.native="canSave"
            class="my-0"
            color="success"
            :loading="updating"
            :disabled="updating"
            large
          >Save</v-btn>
          <v-btn @click.native="popup.type = 'Resetting', popup.show = true" class="my-0" color="error" large flat>
            <b>Reset</b>
          </v-btn>
        </v-flex>
        <v-flex class="px-2 py-4" xs12 md10>
          <v-divider></v-divider>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
          <v-btn @click.native="setupDeleteContent()" color="error" :disabled="deleting" :loading="deleting" large>Delete Content</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-content-popup
    :popup="popup"
    :new-content="newContent"
    :deleting-data="toDelete"
  ></r-content-popup>
</div>
</template>

<script>
import {quillEvent, contentEvent} from '../../main'
import Quill from '../general/Quill.vue'
import ContentPopup from './ContentPopup.vue'
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rQuill: Quill,
    rContentPopup: ContentPopup,
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    updating: false,
    deleting: false,
    toDelete: {},
    content: [],
    contentData: {},
    newContent: {},
    newName: '',
    newText: '',
    quillText: '',
    options: {
      modules: {
        toolbar: [
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [],
          ['bold', 'italic', 'underline'],
          [],
          [{'align': []}],
          [],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [],
          [{'color': []}, {'background': []}]
        ]
      },
      theme: 'snow',
      placeholder: 'Content Description'
    },
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    quillEvent.$on('quillContent', data => {
      const quill = {...data}
      let d = quill.html
      while (d.includes('ql-align-center') || d.includes('ql-align-right')) {
        d = d.replace('ql-align-center', 'text-xs-center')
        d = d.replace('ql-align-right', 'text-xs-right')
      }
      this.newText = d
      this.quillText = quill.text
    })
    contentEvent.$on('reset', () => {
      this.resetNewContent()
    })
    contentEvent.$on('updateContent', () => {
      this.updateContent()
    })
    contentEvent.$on('delete', () => {
      this.deleteContent()
    })
  },
  methods: {
    load () {
      this.loading = true
      this.content = this.$store.getters.content
      this.contentData = {...this.$store.getters.contentByUrl(this.$route.params.contentUrl)}
      this.resetNewContent()
      this.loading = false
    },
    resetNewContent () {
      this.newContent = {...this.contentData}
      this.newName = this.newContent.name
      quillEvent.$emit('syncText', this.newContent.descText)
      this.popup.show = false
    },
    changed () {
      if (typeof this.contentData === 'undefined' || typeof this.newContent === 'undefined') return true
      let name = this.contentData.name.toLowerCase() !== this.newName.toLowerCase()
      let instructions = this.contentData.instructions.toLowerCase() !== this.newContent.instructions.toLowerCase()
      let descBody = this.contentData.descBody.toLowerCase() !== this.quillText.toLowerCase()
      let descText = this.contentData.descText.toLowerCase() !== this.newText.toLowerCase()
      return name || instructions || descBody || descText
    },
    canSave () {
      quillEvent.$emit('getContent')
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.changed()) {
        if (this.newName === '') {
          appMsg.msg = 'Please enter a name for the course content'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.newName.toLowerCase() === 'create') {
          appMsg.msg = 'Please use a different name; that name is reserved.'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.newContent.instructions === '') {
          appMsg.msg = 'Please enter a instructions for the course content'
          this.$store.dispatch('showAppMsg', appMsg)
          return false
        }
        if (this.contentData.name.toLowerCase() !== this.newName.toLowerCase()) {
          for (let c of this.content) {
            if (this.newName.toLowerCase() === c.name.toLowerCase()) {
              appMsg.msg = 'That course content name already exists'
              this.$store.dispatch('showAppMsg', appMsg)
              return false
            }
          }
        }
        this.popup = {
          show: true,
          type: 'Updating Content'
        }
      } else {
        appMsg.msg = 'No change detected'
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateContent () {
      this.updating = true
      let nameChanged = !(this.newContent.name === this.newName)
      this.newContent.name = this.newName
      this.newContent.url = this.$store.getters.formatUrl(this.newContent.name)
      this.newContent.descText = this.newText
      this.newContent.descBody = this.quillText
      this.$store.dispatch('updateContent', this.newContent).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.contentData.name + ' updated!'
        }
        this.updating = false
        this.$store.dispatch('showAppMsg', appMsg)
        if (nameChanged) this.$router.push('/content')
        else this.load()
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.updating = false
        this.$store.dispatch('showAppMsg', appMsg)
      })
    },
    setupDeleteContent () {
      this.toDelete = {...this.contentData}
      this.popup = {
        show: true,
        type: 'Deleting Content'
      }
    },
    deleteContent () {
      this.deleting = true
      const contentName = this.toDelete.name
      this.$store.dispatch('deleteContent', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: contentName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content')
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    }
  }
}
</script>

<style lang="stylus">
   @import "~quill/assets/snow"
</style>



// WEBPACK FOOTER //
// src/components/content/EditContent.vue